import { render } from "./Pdp.vue?vue&type=template&id=3a477d4f"
import script from "./Pdp.vue?vue&type=script&lang=js"
export * from "./Pdp.vue?vue&type=script&lang=js"

import "./Pdp.vue?vue&type=style&index=0&id=3a477d4f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__